<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/job/details/', projectId, jobId]">Zurück zum Job</a>
    </li>
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/jobs']">Übersicht</a>
    </li>
  </ul>
</nav>

<main>
  <h2 class="mb1em">PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Job {{ projectId }}.0006.{{ jobId }} bearbeiten</h2>
  <app-job-form
    *ngIf="jobs"
    [projectId]="projectId"
    [jobId]="jobId"
    [jobsData]="jobs[0]"
    [isUpdateMode]="true">
  </app-job-form>
</main>

<pre *ngIf="devMode" class="datepicker-output">
  <p>Jobs:</p>
  {{ jobs | json }}
</pre>
